import router from '@/router'
import { cloneDeep, isEmpty, isEqual } from 'lodash'
import { createStore } from 'vuex'
import authModule from './modules/auth'
import dbModule from './modules/db'

export default createStore({
  state: {
    user: {} as any,
    currentResource: null as any,
    currentProvider: null as any,
    currentProviderResources: [] as any[],

    providers: [] as any[],
    docState: {
      docs: {
        categories: false,
        parents: false,
        groups: false,
        attachees: false,
        emulated: false,
      },
      scrollTo: ''
    } as any
  },
  mutations: {
    updateUser(state, user: any) { state.user = user },
    updateProviders(state, providers: any[]) { state.providers = providers },

    updateDocState(state, { name, value }: { name: string, value: boolean}) {
      let docStateCopy = cloneDeep(state.docState) // To force object diffing in watchers
      docStateCopy.docs[name] = value
      if (value) docStateCopy.scrollTo = name
      state.docState = docStateCopy
    },

    resetCurrentProvider(state) { state.currentProvider = null },
    updateCurrentProvider(state, provider: any) { state.currentProvider = provider },
    updateCurrentProviderResources(state, resources: any[]) { state.currentProviderResources = resources.sort((a: any, b: any) => a.resourceType.localeCompare(b.resourceType)) },
    
    resetCurrentResource(state) { state.currentResource = null },
    updateCurrentResource(state, resource: any) {
      state.currentResource = resource
      router.push(`/${state.currentProvider.name}/${resource.resourceType}`)
    },
    
    updateResourceCategory(state, category: string) {
      if (category === 'attachment') {
        state.currentResource['attachment']  = true
        state.currentResource.resourceCategory = 'small'
      } else {
        state.currentResource['attachment'] = null
        state.currentResource['attachee'] = null
        state.currentResource.resourceCategory = category
      }
    },
    updateResourceParent(state, parent: string) {
      state.currentResource['parent'] = parent
    },
    updateResourceAttachee(state, attachee: string) {
      state.currentResource['attachee'] = attachee
    },
    updateResourceGroupable(state, groupable: boolean) {
      state.currentResource['groupable'] = groupable
    },
    addResourceEmulated(state, emulated: any) {
      if (!state.currentResource.emulatedResources) state.currentResource.emulatedResources = []
      state.currentResource.emulatedResources.push(emulated)
    },
    removeResourceEmulated(state, emulated: any) {
      let matchIndex = state.currentResource.emulatedResources.findIndex((existing: any) => isEqual(emulated, existing))
      state.currentResource.emulatedResources.splice(matchIndex, 1)
    }
  },
  actions: {},
  getters: {
    appIcons: () => { return require('@/assets/appIcons.json') },
    providerIcons: () => { return require('@/assets/providerIcons.json') },
    categoryIcons: () => { return require('@/assets/categoryIcons.json') }
  },
  modules: {
    auth: authModule,
    db: dbModule
  }
})
